<template>
  <div>
    <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir supprimer ce netlink ?" style="z-index:54000 !important;">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="acceptDelete()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="declineDelete()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup :active.sync="showNetlinkPopup" title="Modification d'un Netlink" style="z-index:54000 !important;">
      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Lien acheté</label>
			<div class="flex">
				<vs-input
					class="w-full"
					placeholder="Lien acheté"
					v-model="modifiedNetlink.urlBought"
					:style="styleValidator('urlBought')"
					@change="validateOne(modifiedNetlink.urlBought, 'urlBought')"
				/>
				<vx-tooltip v-if="validators['urlBought'] && validators['urlBought'].errText !== ''" :text="errText('urlBought')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Landing page</label>
			<div class="flex">
				<vs-input
					class="w-full"
					placeholder="Landing page"
					v-model="modifiedNetlink.landingPage"
					:style="styleValidator('landingPage')"
					@change="validateOne(modifiedNetlink.landingPage, 'landingPaget')"
				/>
				<vx-tooltip v-if="validators['landingPage'] && validators['landingPage'].errText !== ''" :text="errText('landingPage')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Statut</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.status"
					class="w-full select-medium mr-2"
					placeholder="Statut"
					:style="styleValidator('status')"
					@change="validateOne(modifiedNetlink.status, 'status')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in netlinkStatus"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['status'] && validators['status'].errText !== ''" :text="errText('status')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Type ancre</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.anchorType"
					class="w-full select-medium mr-2"
					placeholder="Type ancre"
					:style="styleValidator('anchorType')"
					@change="validateOne(modifiedNetlink.anchorType, 'anchorType')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in anchorTypes"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['anchorType'] && validators['anchorType'].errText !== ''" :text="errText('anchorType')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Type lien</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.linkType"
					class="w-full select-medium mr-2"
					placeholder="Type lien"
					:style="styleValidator('linkType')"
					@change="validateOne(modifiedNetlink.linkType, 'linkType')"
				>
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in linkTypes"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['linkType'] && validators['linkType'].errText !== ''" :text="errText('linkType')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Prix</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedNetlink.price"
					:style="styleValidator('price')"
					@change="validateOne(modifiedNetlink.price, 'price')"
				/>
				<vx-tooltip v-if="validators['price'] && validators['price'].errText !== ''" :text="errText('price')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
      	<div v-if="isRecurringLink(modifiedNetlink.linkType)" class="vx-col" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Renouvellement</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.renew_duration"
					class="w-full select-medium mr-2"
					:style="styleValidator('renew_duration')"
					@change="validateOne(modifiedNetlink.renew_duration, 'renew_duration')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in renewDurations"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['renew_duration'] && validators['renew_duration'].errText !== ''" :text="errText('renew_duration')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-button color="primary" class="mt-2" @click="saveModifiedNetlink()">Enregistrer Netlink</vs-button>
        </div>
      </div>
    </vs-popup>
    <div class="vx-row center_div t-border">
      <vs-table :data="netlink_list" style="overflow: auto;">
          <template slot="header">
              <h3>
              Netlinking
              </h3>
          </template>
        <template slot="thead">
          <vs-th>Lien acheté</vs-th>
          <vs-th>Landing page</vs-th>
          <vs-th>Statut</vs-th>
          <vs-th>Type ancre</vs-th>
          <vs-th>Type lien</vs-th>
          <vs-th>Durée</vs-th>
          <vs-th>Prix</vs-th>
          <vs-th v-if="showNetlinkBuyer">Acheté par</vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope={data}>
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.urlBought"><a :href="tr.urlBought" target="_blank" >{{ tr.urlBought }}</a></vs-td>
            <vs-td :data="tr.landingPage"><a :href="tr.landingPage" target="_blank" >{{ tr.landingPage }}</a></vs-td>
            <vs-td :data="tr.status">{{ getNetlinkStatus(tr.status) }}</vs-td>
            <vs-td :data="tr.anchorType">{{ getNetlinkAnchorType(tr.anchorType) }}</vs-td>
            <vs-td :data="tr.linkType">{{ getNetlinkTypeName(tr.linkType) }}</vs-td>
            <vs-td :data="tr.renew_duration">{{ getNetlinkRenewDuration(tr.renew_duration) }}</vs-td>
            <vs-td :data="tr.price">{{ tr.price ? tr.price + '€' : '0€' }}</vs-td>
            <vs-td :data="tr.society_id" v-if="showNetlinkBuyer">{{ tr.purchase_id ? "Rankwell" : "Client" }}</vs-td>
            <vs-td><vs-button color="primary" @click="modifyNetlink(indextr)" :disabled="disable">Modifier</vs-button></vs-td>
            <vs-td><vs-button color="primary" @click="displayValidationPopup(indextr)" :disabled="disable">Supprimer</vs-button></vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="vx-row center_div">
      	<div class="vx-col" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Lien acheté</label>
			<div class="flex">
				<vs-input
					class="w-full"
					placeholder="Lien acheté"
					v-model="newUrlBought"
					:style="styleValidator('newUrlBought')"
					@change="validateOne(newUrlBought, 'newUrlBought')"
				/>
				<vx-tooltip v-if="validators['newUrlBought'] && validators['newUrlBought'].errText !== ''" :text="errText('newUrlBought')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
      	<div class="vx-col" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Landing page</label>
			<div class="flex">
				<vs-input
					class="w-full"
					placeholder="Landing page"
					v-model="newLandingPage"
					:style="styleValidator('newLandingPage')"
					@change="validateOne(newLandingPage, 'newLandingPage')"
				/>
				<vx-tooltip v-if="validators['newLandingPage'] && validators['newLandingPage'].errText !== ''" :text="errText('newLandingPage')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
      	<div class="vx-col" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Statut</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="newStatus"
					class="w-full select-medium mr-2"
					placeholder="Statut"
					:style="styleValidator('newStatus')"
					@change="validateOne(newStatus, 'newStatus')"
				>
				<vs-select-item
					:key="index"
					:value="item.value"
					:text="item.text"
					v-for="(item, index) in netlinkStatus"
					class="w-full"
				/>
				</vs-select>
				<vx-tooltip v-if="validators['newStatus'] && validators['newStatus'].errText !== ''" :text="errText('newStatus')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
      	<div class="vx-col" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Type ancre</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="newAnchorType"
					class="w-full select-medium mr-2"
					placeholder="Type ancre"
					:style="styleValidator('newAnchorType')"
					@change="validateOne(newAnchorType, 'newAnchorType')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in anchorTypes"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['newAnchorType'] && validators['newAnchorType'].errText !== ''" :text="errText('newAnchorType')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
      	<div class="vx-col" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Type lien</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="newLinkType"
					class="w-full select-medium mr-2"
					placeholder="Type lien"
					:style="styleValidator('newLinkType')"
					@change="validateOne(newLinkType, 'newLinkType')"
				>
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in linkTypes"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['newLinkType'] && validators['newLinkType'].errText !== ''" :text="errText('newLinkType')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
		</div>
      	<div class="vx-col" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Prix</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="newLinkPrice"
					:style="styleValidator('newLinkPrice')"
					@change="validateOne(newLinkPrice, 'newLinkPrice')"
				/>
				<vx-tooltip v-if="validators['newLinkPrice'] && validators['newLinkPrice'].errText !== ''" :text="errText('newLinkPrice')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
      	<div v-if="isRecurringLink(newLinkType)" class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Renouvellement</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="newRenewDuration"
					class="w-full select-medium mr-2"
					:style="styleValidator('newRenewDuration')"
					@change="validateOne(newRenewDuration, 'newRenewDuration')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in renewDurations"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['newRenewDuration'] && validators['newRenewDuration'].errText !== ''" :text="errText('newRenewDuration')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
		<div class="vx-col">
			<vs-button color="primary" class="mt-2" @click="addNetLink()" :disabled="disable">Ajouter Netlink</vs-button>
		</div>
    </div>
    <div class="vx-row center_div">
      <vs-spacer />
      <div class="vx-col">
        <strong>Prix Total : {{ totalLinkPrice }}€</strong>
      </div>
    </div>
  </div>
</template>
<script>
// import Vue from 'vue'
import Netlink from "@/entities/Netlink";
// import NetlinkModifyPopup from "@/components/popups/NetlinkModifyPopup"
import store from "@/store/store";

import Validator from "@/entities/Validator";
import validatorMixin from "@/mixins/validatorMixin";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";


export default {
	name: "NetlinkPopupTable",
	components: {VxTooltip},
	mixins: [dbFieldConvertor, utilsMixin, validatorMixin],
	props: {
		isEdit: {
			type: Boolean,
			default: false
		},
		purchaseId: Number,
		societyId: Number,
		showNetlinkBuyer: Boolean,
		disable: Boolean
	},
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			netlink: Netlink.getFormFields(),
			modifiedNetlink: Netlink.getFormFields(),
			netlink_list: [],
			isNotOriginalPurchase: false,
			netlinkStatus: [
				{text: "Actif", value: 0},
				{text: "En\u00a0attente", value: 1},
				{text: "Refusé", value: 2},
				{text: "Terminé", value: 3},
				{text: "En\u00a0cours\u00a0de\u00a0rédaction", value: 4},
				{text: "Annulé", value: 5}
			],
			anchorTypes: [
				{text: "Brand et Générique", value: 0},
				{text: " Semi optimisée", value: 1},
				{text: "Générique", value: 2},
				{text: "Non optimisée", value: 3},
				{text: "Optimisée", value: 4},
			],
			linkTypes: [],
			renewDurations: [
				{text: "A vie", value: 0},
				{text: "Mensuel", value: 1},
				{text: "Annuel", value: 12},
			],
			newUrlBought: "",
			newLandingPage: "",
			newAnchorType: null,
			newLinkType: null,
			newLinkPrice: 0,
			newRenewDuration: null,
			newStatus: null,
			totalLinkPrice: 0,
			showNetlinkPopup: false,
			showValidationPopup: false,
			selectedNetlink: null,
			netlinkTableLock: false,
			// Validator Objects
			NetlinkValidationObjects: {
				urlBoughtValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: true
				},
				landingPageValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: true
				},
			},
			ModifiedNetlinkValidationObjects: {
				urlBoughtValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: true
				},
				landingPageValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: true
				},
			},
			validators: {},
			check: true,
			netlink_types: []
		};
	},
	created() {
		this.$store.dispatch("getAllNetlink");
		/*
		 * this.netlink = Netlink.getFormFields();
		 * this.modifiedNetlink = Netlink.getFormFields();
		 */
		if(this.$props.disable){
			this.netlinkTableLock = this.$props.disable;
		}
	},
	async mounted() {
		//console.log("Check purchaseId", this.$props.purchaseId);
		await this.getAllNetlinkTypes();
		if(this.$props.purchaseId){
			//console.log("this.$props.purchaseId", this.$props.purchaseId);
			if(this.isEdit){
				//console.log("mounted check");
				this.checkPurchaseHaveNetlink();
			}
		}
		if(this.netlink_list && this.netlink_list.length > 0){
			this.totalLinkPrice = this.getPurchasePrice();
		}
		/*
		 * else if(this.$props.societyId){
		 *   this.checkSocietyHaveNetlink()
		 * }
		 */
	},
	updated(){
		if(this.netlink_list.length > 0){
			this.totalLinkPrice = this.getPurchasePrice();
		}
	},
	computed: {
		netlinks: () => {
			return store.state.netlink;
		}
	},
	watch: {
		newAnchorType: function(){
			//console.log("newAnchorType");
			this.netlink.anchorType = this.newAnchorType;
		},
		newLandingPage: function(){
			//console.log("newLandingPage");
			this.netlink.landingPage = this.newLandingPage;
		},
		newUrlBought: function(){
			//console.log("newUrlBought");
			this.netlink.urlBought = this.newUrlBought;
		},
		newLinkType: function(){
			//console.log("newLinkType");
			this.netlink.linkType = this.newLinkType;
		},
		newLinkPrice: function(){
			//console.log("newLinkPrice");
			this.netlink.price = this.newLinkPrice;
		},
		newRenewDuration: function(){
			//console.log("newRenewDuration");
			this.netlink.renew_duration = this.newRenewDuration;
		},
		newStatus: function(){
			//console.log("newStatus");
			this.netlink.status = this.newStatus;
		},
		netlinks: function(){
			if(this.$props.isEdit && this.$props.purchaseId){
				// //console.log("netlinks check");
				// this.checkPurchaseHaveNetlink();
			}
		},
		netlink_types: function(data){
			this.linkTypes = data.filter(row => row.is_dns == 0);
		},
		purchaseId: function(){
			//console.log("purchase_id updated");
			if(this.isEdit){
				//console.log("purchaseId check")
				this.checkPurchaseHaveNetlink();
			}
		},
		societyId: function(){
			//console.log("society_id updated");
			/*
			 *   if(!this.purchaseId){
			 *     //console.log("No purchase_id:", this.purchaseId)
			 *     this.netlink_list = this.netlinks.filter(netlink => netlink.society_id == this.$props.societyId)
			 *   }
			 */
		},
		netlink_list: function(){
			//console.log("netlink_list updated");
			this.totalLinkPrice = this.getPurchasePrice();
			this.$emit("netlink-update", this.netlink_list.length);
		},
	},
	methods: {
		getAllNetlinkTypes(){
			return new Promise((resolve, reject) => {
				this.$http.get(this.apiUrl + "netlink/type/all").then(res => {
					//console.log("getAllNetlinkTypes res.data", res.data);
					this.netlink_types = res.data;
					resolve(true);
				})
					.catch(e => {
						reject(e);
					});
			});
		},

		isRecurringLink(link_type){
			let foundIndex = this.netlink_types.findIndex(row => row.id == link_type);
			if(foundIndex >= 0){
				if(this.netlink_types[foundIndex].recurrency == 1) return true;
			}
			return false;
		},
		getIsOriginalPurchase(){
			return !this.isNotOriginalPurchase;
		},
		getPurchasePrice(){
			let price = 0;
			// //console.log("getPurchasePrice")
			for(let i = 0; i < this.netlink_list.length; i++){
				// //console.log("this.netlink_list[i].price", this.netlink_list[i].price)
				price += parseFloat(this.netlink_list[i].price);
			}
			// //console.log("price", price)
			return price.toFixed(2);
		},
		getNetlinkListData(){
			return this.netlink_list;
		},

		getNetlinkTypeName(netlinkTypeId){

			let foundNetlinkType = this.netlink_types.findIndex(row => row.id == netlinkTypeId);
			if(foundNetlinkType >= 0) return this.netlink_types[foundNetlinkType].name;
			else" ";
		},

		getNetlinkRenewDuration(renew_duration){
			// //console.log("renew_duration", renew_duration)
			let foundRenewDuration = this.renewDurations.findIndex(rd => rd.value == renew_duration);
			// //console.log("foundRenewDuration", foundRenewDuration)
			if(foundRenewDuration >= 0){
				return this.renewDurations[foundRenewDuration].text;
			}
			return "A\u00a0vie";
		},

		validateOne(val, name){
			let value = val;
			value === 0 ? value = "0" : "";
			let constname = "";
			switch(name){
			case"price":
			case"newLinkPrice":
				value ? value = String(val) : "";
				constname = "priceConstraint";
				break;
			case"newUrlBought":
			case"newLandingPage":
			case"urlBought":
			case"landingPage":
				constname = "websiteConstraint";
				break;
			default:
				value ? value = String(val) : "";
				value == null ? value = "" : "";
				constname = "isNumberConstraint";
				break;
			}
			this.validators[name] = new Validator({constraintName: constname});
			this.validators[name].check(value);
			val == null ? this.validators[name].valid == false : "";
			this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
			this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			this.$forceUpdate();
		},
		errText(name){
			if(this.validators[name] && this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators && this.validators[name] && this.validators[name].valid == false && this.validators[name].errText !== ""){
				return "display: inline-block; width: calc(100% - 30px) !important; border: 1px solid red !important; border-radius: 5px;";
			}
			else if(this.validators && this.validators[name] && this.validators[name].errText == ""){
				return "display: inline-block; border: 1px solid green !important; border-radius: 5px;";
			}
			else{
				return "display: inline-block; border: none !important; border-radius: none;";
			}
		},

		addNetLink(){
			this.check = true;
			let fields = ["newUrlBought", "newLandingPage", "newStatus", "newAnchorType", "newLinkType", "newLinkPrice", "newRenewDuration"];
			let fieldsVal = [this.newUrlBought, this.newLandingPage, this.newStatus, this.newAnchorType, this.newLinkType, this.newLinkPrice, this.newRenewDuration];
			let constname = "";

			for(let i = 0; i < fields.length; i++){
				let value = fieldsVal[i];
				value === 0 ? value = "0" : "";
				switch(fields[i]){
				case"newUrlBought":
				case"newLandingPage":
					constname = "websiteConstraint";
					break;
				case"newLinkPrice":
					value ? value = String(value) : "";
					constname = "priceConstraint";
					break;
				default:
					String(value) ? value = String(value) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}

				this.validators[fields[i]] = new Validator({constraintName: constname});
				this.validators[fields[i]].check(value);
				fieldsVal[i] == null ? this.validators[fields[i]].valid = false : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "" ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				if(fields[i] == "newRenewDuration" && !this.isRecurringLink(this.newLinkType)){
					this.newRenewDuration = null;
					this.validators[fields[i]].valid = true;
				}
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";

			}

			// this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				this.newLinkPrice = String(this.newLinkPrice).replace(",", ".");
				this.newLinkPrice = Number(this.newLinkPrice);

				/*
				 * if(this.$props.linkType){ // TODO Link type
				 *   //console.log(this.$props.linkType)
				 *   this.netlink.linkType = this.$props.linkType
				 * }
				 */
				this.netlink.status = 0; // Actif par défaut

				/*
				 * if(this.isFromNDD){
				 *   this.netlink.linkType = 3
				 * }
				 */

				if(!this.isRecurringLink(this.netlink.linkType)){
					this.netlink.renew_duration = null;
				}

				this.netlink.dns_id = this.newNetlinkDns ? this.newNetlinkDns : null;
				// //console.log("this.netlink", this.netlink)
				let newNetlink = new Netlink(this.netlink);
				this.netlink_list.push(newNetlink);
				newNetlink.price = this.newLinkPrice;
				this.totalPurchasePrice = this.totalPurchasePrice + this.newLinkPrice;
				this.updateTotalPrice(this.totalPurchasePrice); // TO REMOVE
				this.showNewNetlink = false;
			}
		},

		newNetlink(){
			if(!this.checkAllRequiredFields()){
				this.$vs.notify({
					title: "Echec",
					text: "Tous les champs nécessaires ne sont pas remplis."
				});
				return false;
			}
			if(!this.checkAllFieldsError()){
				this.$vs.notify({
					title: "Echec",
					text: "Certains champs contiennent une valeur erronée."
				});
				return false;
			}

			/*
			 * this.netlink.landingPage = this.netlink.landingPage;
			 * this.netlink.urlBought = this.netlink.urlBought;
			 */

			// //console.log("url test",this.netlink.urlBought, this.netlink.landingPage )


			// // //console.log("this.$props.purchaseId", this.$props.purchaseId)
			if(this.$props.purchaseId){
				// //console.log(this.$props.purchaseId)
				this.netlink.purchase_id = this.$props.purchaseId;
			}
			// //console.log("this.$props.societyId", this.$props.societyId)
			if(this.$props.societyId){
				// //console.log(this.$props.societyId)
				this.netlink.society_id = this.$props.societyId;
			}

			let newNetlink = new Netlink(this.netlink);
			// //console.log(newNetlink)
			newNetlink.create((err, res) => {
				if(err) //console.log(err);
				if(res) {
					// //console.log(res)
					this.$store.dispatch("getAllNetlink");
				}
			});
		},

		deleteNetlink(netlinkId){
			// //console.log(netlinkId)
			this.netlink_list.splice(netlinkId, 1);
		},

		acceptDelete(){
			this.deleteNetlink(this.selectedNetlink);
			this.showValidationPopup = false;
		},

		declineDelete(){
			this.selectedNetlink = null;
			this.showValidationPopup = false;
		},

		displayValidationPopup(netlinkId){
			this.selectedNetlink = netlinkId;
			this.showValidationPopup = true;
		},

		modifyNetlink(netlinkIndex){

			/*
			 *  //console.log(netlink)
			 * Initialisation des données pour le popup
			 */
			this.modifiedNetlinkIndex = null; // Always reset data before assigning it
			this.modifiedNetlink = null; // Always reset data before assigning it
			this.modifiedNetlinkIndex = netlinkIndex; // Always reset data before assigning it
			this.modifiedNetlink = JSON.parse(JSON.stringify(this.netlink_list[netlinkIndex]));
			/*
			 * this.modifiedNetlink = {
			 *       id: this.netlink_list[netlinkIndex].id,
			 *       urlBought: this.netlink_list[netlinkIndex].url_bought,
			 *       anchorType: this.netlink_list[netlinkIndex].anchor_type,
			 *       landingPage: this.netlink_list[netlinkIndex].landing_page,
			 *       status: this.netlink_list[netlinkIndex].status,
			 *       linkType: this.netlink_list[netlinkIndex].link_type,
			 *       domainAuthority: this.netlink_list[netlinkIndex].domain_authority,
			 *       pageAuthority: this.netlink_list[netlinkIndex].page_authority,
			 *       trustFlow: this.netlink_list[netlinkIndex].trust_flow,
			 *       citationFlow: this.netlink_list[netlinkIndex].citation_flow,
			 *       externalLinks: this.netlink_list[netlinkIndex].external_links,
			 *       refDomains: this.netlink_list[netlinkIndex].ref_domains,
			 *       purchase_id: this.netlink_list[netlinkIndex].purchase_id,
			 *       society_id: this.netlink_list[netlinkIndex].society_id,
			 *       creation_date: this.netlink_list[netlinkIndex].creation_date,
			 *       price: this.netlink_list[netlinkIndex].price,
			 *       renew_duration: this.netlink_list[netlinkIndex].renew_duration,
			 *     }
			 */
			this.showNetlinkPopup = true;
		},
		saveModifiedNetlink(){
			this.check = true;
			let fields = ["urlBought", "landingPage", "status", "anchorType", "linkType", "price", "renew_duration"];
			let constname = "";

			for(let i = 0; i < fields.length; i++){
				let value = this.modifiedNetlink[fields[i]];
				value === 0 ? value = "0" : "";
				switch(fields[i]){
				case"urlBought":
				case"landingPage":
					constname = "websiteConstraint";
					break;
				case"price":
					value ? value = String(value) : "";
					constname = "priceConstraint";
					break;
				default:
					value ? value = String(value) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}
				this.validators[fields[i]] = new Validator({constraintName: constname});
				this.validators[fields[i]].check(value);
				this.modifiedNetlink[fields[i]] == null ? this.validators[fields[i]].valid = false : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "" ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				if(fields[i] == "renew_duration" && !this.isRecurringLink(this.modifiedNetlink.linkType)){
					this.modifiedNetlink.renew_duration = null;
					this.validators[fields[i]].valid = true;
				}
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";
			}

			this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				/*
				 * if(!this.checkAllModifiedRequiredFields()){
				 *   this.$vs.notify({
				 *     title: "Echec",
				 *     text: "Certains champs contiennent une valeur erronée."
				 *   });
				 *   return false
				 * }
				 * if(!this.checkModifiedAllFieldsError()){
				 *   this.$vs.notify({
				 *     title: "Echec",
				 *     text: "Certains champs contiennent une valeur erronée."
				 *   });
				 *   return false
				 * }
				 */

				/*
				 * let re = new RegExp('([T|Z])', 'g')
				 * if(this.modifiedNetlink.creation_date) this.modifiedNetlink.creation_date = this.modifiedNetlink.creation_date.replace(re, " ")
				 * let params = {
				 *   id: this.modifiedNetlink.id,
				 *   urlBought: this.modifiedNetlink.url_bought,
				 *   anchorType: this.modifiedNetlink.anchor_type,
				 *   landingPage: this.modifiedNetlink.landing_page,
				 *   status: this.modifiedNetlink.status,
				 *   linkType: this.modifiedNetlink.link_type,
				 *   domainAuthority: this.modifiedNetlink.domain_authority,
				 *   pageAuthority: this.modifiedNetlink.page_authority,
				 *   trustFlow: this.modifiedNetlink.trust_flow,
				 *   citationFlow: this.modifiedNetlink.citation_flow,
				 *   externalLinks: this.modifiedNetlink.external_links,
				 *   refDomains: this.modifiedNetlink.ref_domains,
				 *   purchase_id: this.modifiedNetlink.purchase_id,
				 *   society_id: this.modifiedNetlink.society_id,
				 *   creation_date: this.modifiedNetlink.creation_date,
				 *   price: this.modifiedNetlink.price,
				 *   renew_duration: this.modifiedNetlink.renew_duration,
				 * }
				 * //console.log("params")
				 * //console.log(params)
				 * let savedModifiedNetlink = new Netlink(params)
				 * //console.log(savedModifiedNetlink)
				 * savedModifiedNetlink.update((err, res) => {
				 *   if(err) //console.log(err)
				 *   if(res) {
				 *     //console.log(res)
				 *     this.$store.dispatch("getAllNetlink");
				 */
				this.modifiedNetlink.price = String(this.modifiedNetlink.price).replace(",", ".");
				this.modifiedNetlink.price = Number(this.modifiedNetlink.price);
				this.totalPurchasePrice = this.totalPurchasePrice - this.netlink_list[this.modifiedNetlinkIndex].price + this.modifiedNetlink.price;
				this.netlink_list[this.modifiedNetlinkIndex] = new Netlink(this.modifiedNetlink);
				this.netlink_list[this.modifiedNetlinkIndex].price = this.modifiedNetlink.price;
				this.updateTotalPrice(this.totalPurchasePrice);
				this.showNetlinkPopup = false;
				window.dispatchEvent(new Event("resize"));
				/*
				 *   }
				 * })
				 */
			}
		},
		updateTotalPrice(price = null){
			if(price == null){
				this.$emit("update-total-price", this.totalPurchasePrice);
			}
			else{
				this.$emit("update-total-price", price);
			}
		},
		checkPurchaseHaveNetlink(){
			//console.log("checkPurchaseHaveNetlink", this.$props.purchaseId);
			if(this.$props.purchaseId){
				this.$http.get(this.apiUrl+"netlink/allpn/"+this.$props.purchaseId)
					.then(results => {
						this.netlink_list = [];
						// let tmp = results.data.filter(nl => nl.purchase_id == this.$props.purchaseId);
						for(let result of results.data){
							this.netlink_list.push({
								id: result.id,
								urlBought: result.url_bought,
								anchorType: result.anchor_type,
								landingPage: result.landing_page,
								status: result.status,
								linkType: result.link_type,
								domainAuthority: result.domain_authority,
								pageAuthority: result.page_authority,
								trustFlow: result.trust_flow,
								citationFlow: result.citation_flow,
								externalLinks: result.external_links,
								refDomains: result.ref_domains,
								purchase_id: result.purchase_id,
								society_id: results.society_id,
								creation_date: result.creation_date,
								price: result.link_type == 0 && result.pn_price ? result.pn_price : result.price,
								renew_duration: result.renew_duration,
								provider_id: result.provider_id
							});
						}
						// //console.log("result check", tmp.length);
					})
					.catch(err => {
						//console.log(err);
						this.netlink_list = [];
					});
			}
			// let netlinksFiltered = this.netlinks.filter(netlink => netlink.purchase_id == this.$props.purchaseId)
			// //console.log("checkPurchaseHaveNetlink")
			// // //console.log(this.$props.purchaseId)
			// // //console.log(this.netlinks)
			// // //console.log(netlinksFiltered)
			// if(netlinksFiltered.length > 0){

			/*
			 *   this.netlink_list = netlinksFiltered.map(netlink => {
			 *     return {
			 *       id: netlink.id,
			 *       urlBought: netlink.url_bought,
			 *       anchorType: netlink.anchor_type,
			 *       landingPage: netlink.landing_page,
			 *       status: netlink.status,
			 *       linkType: netlink.link_type,
			 *       domainAuthority: netlink.domain_authority,
			 *       pageAuthority: netlink.page_authority,
			 *       trustFlow: netlink.trust_flow,
			 *       citationFlow: netlink.citation_flow,
			 *       externalLinks: netlink.external_links,
			 *       refDomains: netlink.ref_domains,
			 *       purchase_id: netlink.purchase_id,
			 *       society_id: netlink.society_id,
			 *       creation_date: netlink.creation_date,
			 *       price: netlink.price,
			 *       renew_duration: netlink.renew_duration,
			 *     }
			 *   })
			 * }
			 */
		},

		checkSocietyHaveNetlink(){
			let netlinksFiltered = this.netlinks.filter(netlink => netlink.purchase_id == this.$props.purchaseId);
			/*
			 * //console.log("checkPurchaseHaveNetlink")
			 * //console.log(this.$props.purchaseId)
			 * //console.log(this.netlinks)
			 * //console.log(netlinksFiltered)
			 */
			if(netlinksFiltered.length > 0){
				this.netlink_list = netlinksFiltered;
			}
		},

		/**
		 * Checks if landing page link is valid
		 */
		checkLandingPage(){
			this.checkHandler(this.netlink.landingPage, this.NetlinkValidationObjects.landingPageValidationObject);
		},

		/**
		 * Checks if urlBought link is valid
		 */
		checkUrlBought(){
			this.checkHandler(this.netlink.urlBought, this.NetlinkValidationObjects.urlBoughtValidationObject);
		},

		/**
		 * Checks if landing page link is valid
		 */
		checkModifiedLandingPage(){
			this.checkHandler(this.modifiedNetlink.landingPage, this.ModifiedNetlinkValidationObjects.landingPageValidationObject);
		},

		/**
		 * Checks if urlBought link is valid
		 */
		checkModifiedUrlBought(){
			this.checkHandler(this.modifiedNetlink.urlBought, this.ModifiedNetlinkValidationObjects.urlBoughtValidationObject);
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllRequiredFields(){
			let requiredFieldsOk = true;

			Object.entries(this.NetlinkValidationObjects).forEach(entry => {
				const [key, value] = entry;
				if(value.required && !value.valid && requiredFieldsOk){
					requiredFieldsOk = value.valid;
				}
			});

			return requiredFieldsOk;
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllFieldsError(){
			let fieldsErrorOk = true;

			Object.entries(this.NetlinkValidationObjects).forEach(entry => {
				const [key, value] = entry;
				if(value.notValid && fieldsErrorOk){
					fieldsErrorOk = false;
				}
			});

			return fieldsErrorOk;
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllModifiedRequiredFields(){
			let requiredFieldsOk = true;

			Object.entries(this.NetlinkValidationObjects).forEach(entry => {
				const [key, value] = entry;
				if(value.required && !value.valid && requiredFieldsOk){
					requiredFieldsOk = value.valid;
				}
			});

			return requiredFieldsOk;
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllModifiedFieldsError(){
			let fieldsErrorOk = true;

			Object.entries(this.NetlinkValidationObjects).forEach(entry => {
				const [key, value] = entry;
				if(value.notValid && fieldsErrorOk){
					fieldsErrorOk = false;
				}
			});

			return fieldsErrorOk;
		},

	},
};
</script>
<style scoped>

</style>
